import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSliderModule } from '@angular/material/slider';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTimepickerModule } from '@angular/material/timepicker';
import { RouterModule } from '@angular/router';
import { CodemirrorModule } from '@ctrl/ngx-codemirror';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from '@danielmoncada/angular-datetime-picker';
import { NbEvaIconsModule } from '@nebular/eva-icons';
import {
  NbAccordionModule,
  NbButtonModule,
  NbCardModule,
  NbCheckboxModule,
  NbDialogModule,
  NbIconModule,
  NbInputModule,
  NbListModule,
  NbMenuModule,
  NbPopoverModule,
  NbRadioModule,
  NbSelectModule,
  NbSpinnerModule,
  NbTabsetModule,
  NbToastrModule,
  NbToggleModule,
  NbTooltipModule,
  NbWindowModule
} from '@nebular/theme';
import { NgSelectModule } from '@ng-select/ng-select';
import { BoldPipe } from './pipes/bold.pipe';
import { CustomValueHandlingPipe } from './pipes/custom-value-handling.pipe';
import { FormatPipe } from './pipes/format.pipe';
import { ReplaceDashesPipe } from './pipes/replace-dashes.pipe';
import { ReplaceUnderscorePipe } from './pipes/replace-underscore.pipe';
import { SplitWordUppercasePipe } from './pipes/split-word-uppercase.pipe';
import { TimestampDatePipe } from './pipes/timestamp-date.pipe';
import { EditTableColumnsComponent } from './ui/edit-table-columns/edit-table-columns.component';
import { MetadataTableCellComponent } from './ui/metadata-table-cell/metadata-table-cell.component';
import { MoreDetailsCellComponent } from './ui/more-details-cell/more-details-cell.component';
import { NgxConfirmModalComponent } from './ui/ngx-confirm-modal/ngx-confirm-modal.component';
import { NgxGenericModalComponent } from './ui/ngx-generic-modal/ngx-generic-modal.component';
import { NgxMatTableComponent } from './ui/ngx-mat-table/ngx-mat-table.component';
import { PreviewContentComponent } from './ui/preview-content/preview-content.component';
import { SpinnerComponent } from './ui/spinner/spinner.component';
import { StatusLightComponent } from './ui/status-light/status-light.component';
import { ValidatorDirective } from './validation/validation_regex';

const ANGULAR_MODULES = [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, DragDropModule];

const DECLARED = [
  // Components
  NgxMatTableComponent,
  SpinnerComponent,
  EditTableColumnsComponent,
  NgxGenericModalComponent,
  StatusLightComponent,
  NgxConfirmModalComponent,
  MetadataTableCellComponent,
  MoreDetailsCellComponent,
  PreviewContentComponent,
  // Pipes
  BoldPipe,
  CustomValueHandlingPipe,
  FormatPipe,
  ReplaceDashesPipe,
  SplitWordUppercasePipe,
  ReplaceUnderscorePipe,
  TimestampDatePipe,
  //Directives
  ValidatorDirective
];

const MATERIAL_MODULES = [
  MatButtonModule,
  MatFormFieldModule,
  MatIconModule,
  MatInputModule,
  MatMenuModule,
  MatPaginatorModule,
  MatSortModule,
  MatTableModule,
  MatTabsModule,
  MatNativeDateModule,
  MatDatepickerModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatTimepickerModule,
  MatSliderModule
];

const NEBULAR_MODULES = [
  NbEvaIconsModule,
  NbAccordionModule,
  NbButtonModule,
  NbCheckboxModule,
  NbDialogModule,
  NbIconModule,
  NbInputModule,
  NbListModule,
  NbMenuModule,
  NbSelectModule,
  NbSpinnerModule,
  NbToastrModule,
  NbToggleModule,
  NbTooltipModule,
  NbWindowModule,
  NbCardModule,
  NbTabsetModule,
  NbPopoverModule,
  NbRadioModule
];

const THIRD_PARTY_MODULES = [CodemirrorModule, OwlDateTimeModule, OwlNativeDateTimeModule, NgSelectModule];

@NgModule({
  imports: [...ANGULAR_MODULES, ...MATERIAL_MODULES, ...NEBULAR_MODULES, ...THIRD_PARTY_MODULES, ...DECLARED],
  exports: [...ANGULAR_MODULES, ...MATERIAL_MODULES, ...NEBULAR_MODULES, ...THIRD_PARTY_MODULES, ...DECLARED]
})
export class SharedModule {}
